























import Vue from 'vue'

import { HomeTableProps } from '@/components/listing/home-table/home-table.constants'

/**
 * Component with table used both by mailboxes and projects home
 */
export default Vue.extend({
  name: 'HomeTable',

  props: {
    ...HomeTableProps,
  },

  computed: {
    showEmptyState(): boolean {
      return this.tableData.length === 0 && !this.isLoading
    },
    propsBinds(): any {
      return {
        type: this.type,
        tableData: this.tableData,
        isLoading: this.isLoading,
        fromAll: this.fromAll,
        fromEntityHome: this.fromEntityHome,
      }
    },
  },
  methods: {
    clearBulkEdit() {
      // @ts-ignore
      this.$refs.homeTableDesktop.clearBulkEdit()
    },
  },
})
